import { Navigate } from "react-router-dom";

/**
 * Staff cooperative “service request” queue is retired.
 * Membership is managed via the existing member registration / approval flows.
 */
export default function CooperativeRequestsPage() {
  return <Navigate to="/super_admin/investor_portal/requests/real-estate" replace />;
}
